<template>
  <CRow>
    <CCol col="12" lg="12">
      <div class="detail-div">
        <CRow>
          <div>
            <CModal :title="submitType === 'Update' ? $lang.post.crud.edit : $lang.common.general.reason" size="lg"
              :show.sync="largeModal" :no-close-on-backdrop="true" color="primary">
              <CCardBody>
                <CRow>
                  <CCol md="12">
                    <c-textarea v-model="comboOffer.reason" :rows="5" :cols="10" placeholder="Add Reason"></c-textarea>
                  </CCol>
                  <CCol md="6">
                    <div class="form-group">
                      <CButton color="primary" v-c-tooltip="$lang.buttons.general.crud.submit" :disabled="submitted"
                        v-on:click="blockPost(statusId)">
                        Submit
                      </CButton>
                    </div>
                  </CCol>
                </CRow>
              </CCardBody>
              <template #footer style="display: none">
                <CButton @click="darkModal = false" color="danger" style="display: none">Discard</CButton>
                <CButton @click="darkModal = false" color="success" style="display: none">Accept</CButton>
              </template>
            </CModal>
          </div>
        </CRow>
        <CRow>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">
              {{ $lang.comboOffer.form.user }}
            </p>
            <p class="custome-detail">
              <ProfilerDetail :username="comboOffer.userWithCompany" :profilerId="comboOffer.userId"></ProfilerDetail>
            </p>
          </CCol>
          <CCol sm="6" md="4" lg="4" v-show="comboOffer.branchInfo" v-if="comboOffer.whose === 'Company'">
            <p class="custome-labal">{{ $lang.post.form.branch }}</p>
            <BranchComponent :data="comboOffer.branchInfo"></BranchComponent>
          </CCol>
          <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">Title</p>
            <p class="custome-detail">{{ comboOffer.title }}</p>
          </CCol>
          <!-- <CCol sm="6" md="4" lg="4">
            <p class="custome-labal">{{ $lang.comboOffer.form.subCategory }}</p>
            <p class="custome-detail">{{ comboOffer.subCategory.title }}</p>
          </CCol> -->
          <CCol sm="12" md="12" lg="12">
            <p class="custome-labal">{{ $lang.comboOffer.form.description }}</p>
            <Description :title="$lang.comboOffer.form.description" :content="comboOffer.description" :length="90" />
          </CCol>
          <CCol lg="12">
            <table class="table table-bordered">
              <tr>
                <td><b>Title</b></td>
                <td><b>Quantity</b></td>
              </tr>
              <tr v-for="(comboOffer,index) in comboOffer.items">
                <td>{{ comboOffer.title }}</td>
                <td>{{ comboOffer.quantity }}</td>
              </tr>
            </table>
          </CCol>
        </CRow>
        <EntityTimeStamp :createdAt="comboOffer.createdAt" :updatedAt="comboOffer.updatedAt"></EntityTimeStamp>
        <CRow v-show="comboOffer.blockedReason">
          <CCol sm="12" align="left">
            <strong>Blocked Reason: </strong> {{ comboOffer.blockedReason }}
          </CCol>
        </CRow>
        <CRow v-if="!comboOffer.blockedReason && comboOffer.isStatus != 'Closed'">
            <CCol sm="12" align="left">
              <CButton :color="statusColor" v-c-tooltip="statusLabel" v-on:click="beforeBlocked()">
                {{ statusLabel }}
              </CButton>
            </CCol>
        </CRow>
      </div>
    </CCol>
  </CRow>
</template>
<script>
import Vue from "vue";
import VueForm from "vue-form";
import store from "/src/store/store.js";
import BranchComponent from "/src/views/branch/Component";
import {
  comboOffer,
  industry,
  duration,
  currencytype,
  users,
  skills,
} from "/src/store/url.js";
import { Mixin } from "/src/mixins/index.js";
import options from "/src/validations/validations.js";
import VueNotifications from "vue-notifications";
import VueToasted from "vue-toasted";
import moment from "moment";
import Description from "/src/views/Description";
import ProfilerDetail from "/src/views/ProfilerDetail.vue";
import { serverBus } from "/src/main";
import EntityTimeStamp from "/src/components/EntityTimeStamp";

function toast({ title, message, type, timeout, cb }) {
  if (type === VueNotifications.types.warn) type = "show";
  return Vue.toasted[type](message, {
    duration: timeout,
    position: "top-left",
  });
}

Vue.use(VueToasted);
const optionss = {
  success: toast,
  error: toast,
  info: toast,
  warn: toast,
  position: "top-center",
};
Vue.use(VueNotifications, optionss);
Vue.use(VueForm, options);

export default {
  name: "ComboOfferEdit",
  mixins: [Mixin],
  components: {
    Description,
    ProfilerDetail,
    EntityTimeStamp,
    BranchComponent
  },
  data() {
    return {
      submitType: "",
      userId: "",
      largeModal: false,
      statusId: "",
      statusLabel: "Block",
      statusColor: "danger",
      submitted: false,
      showTax: true,
      err_msg: "",
      dismissCountDown: 0,
      postTypeList: [],
      statusOption: [],
      industryOptions: [],
      subIndustryOptions: [],
      resourceTypeOptions: [],
      currencyOptions: [],
      durationOptions: [],
      remoteWorkOptions: [],
      userOptions: [],
      skillsOptions: [],
      selectedSkills: [],
      getSkills: [],
      self: this,
      module: comboOffer,
      moduleIndustry: industry,
      moduleDuration: duration,
      moduleCurrency: currencytype,
      moduleSkills: skills,
      moduleUser: users,
      comboOffer: {
        fuelType : "",
        transactionType : "",
        category : "",
        reason:"",
        isActive : "",
      },
    };
  },

  mounted() {
    store.commit("showLoader", true);
    const type = {
      YES: "Yes",
      NO: "No",
    };
    let self = this;
    self.statusOption.push(
      { value: "1", label: "Active" },
      { value: "0", label: "InActive" },
      { value: "2", label: "Block" },
      { value: "3", label: "Closed" },
      { value: "4", label: "Draft" }
    );
    self.dismissCountDown = 0;
    const id = this.$route.params.id;

    self.remoteWorkOptions.push(
      { value: type.YES, label: type.YES },
      { value: type.NO, label: type.NO }
    );
    self.dismissCountDown = 0;
    self.editId = id;
    axios
      .get(this.viewUrlApi(this.module, id))
      .then((response) => {
        if (response.data) {
          const responseData = response.data.data;
          self.comboOffer = responseData;
          self.comboOffer.fuelType = responseData.fuelType.title ?? "",
          self.comboOffer.transactionType = responseData.transactionType.title ?? "",
          self.comboOffer.category = responseData.category.title ?? "",
          self.comboOffer.isActive = responseData.status,
          self.comboOffer.createdAt = responseData.createdAt;
          self.comboOffer.updatedAt = responseData.updatedAt;
          store.commit("showLoader", false); // Loader Off
        }
      })
      .catch(function (error) {
        store.commit("showLoader", false); // Loader Off
      });
  },
  methods: {
    showProfile(userId) {
      serverBus.$emit("profilerId", userId);
    },

    getHumanDate: function (date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },

    getStatusLabel(getStatus) {
      let valObj = " ";
      valObj = this.statusOption.filter(function (elem) {
        if (elem.value == getStatus) return elem.value;
      });
      if (valObj.length > 0) return valObj[0].label;
    },

    beforeBlocked() {
      let self = this;
      self.comboOffer.reason = "";
      if (self.comboOffer.isActive === 1) {
        this.largeModal = true;
      } else {
        this.blockPost(self.statusId);
      }
    },

    blockPost(statusId) {
      let self = this;
      self.submitted = true; //Enable Button
      if (self.comboOffer.isActive === 1) {
        if (self.comboOffer.reason === "") {
          self.submitted = false; //Enable Button
          return false;
        }
        this.$swal({
          title: this.$lang.common.status.want_to_block,
          type: "warning",
          showCancelButton: true,
          confirmButtonColor: "#e55353",
          confirmButtonText: this.$lang.common.status.yes_block,
          cancelButtonText: this.$lang.common.status.cancel,
        }).then((result) => {
          if (result.value) {
            const id = this.$route.params.id;

            setTimeout(() => {
              let self = this;
              const postData = {
                status: statusId,
                reason: self.comboOffer.reason,
              };
              let status, button;
              if (self.statusId === "1") {
                self.statusId = "2";
                self.statusColor = "danger";
                status = this.getStatusLabel(1);
                button = "Block";
              } else {
                self.statusId = "1";
                self.statusColor = "success";
                status = "Blocked";
                button = this.getStatusLabel(1);
              }

              axios
                .post(this.statusUrlWeb(this.module, id), postData)
                .then(function (response) {
                  if (response.data.code === 200) {
                    self.comboOffer.isStatus = status;
                    self.statusLabel = button;
                    self.largeModal = false;
                    self.submitted = false; //Enable Button
                    self.$router.go();
                  } else {
                    self.err_msg = response.data.message;
                    self.dismissCountDown = 10;
                  }
                })
                .catch(function (error) {
                  self.submitted = false; //Enable Button
                });
            }, 500);
          }
        });
      } else {
        const id = this.$route.params.id;
        let self = this;
        const postData = {
          status: statusId,
          reason: "",
        };
        let status, button;
        if (self.statusId === "1") {
          self.statusId = "2";
          self.statusColor = "danger";
          status = this.getStatusLabel(1);
          button = "Block";
        } else {
          self.statusId = "1";
          self.statusColor = "success";
          status = "Blocked";
          button = this.getStatusLabel(1);
        }
        axios
          .post(this.statusUrlWeb(this.module, id), postData)
          .then(function (response) {
            if (response.data.code === 200) {
              self.comboOffer.isStatus = status;
              self.statusLabel = button;
              self.largeModal = false;
              self.submitted = false; //Enable Button
              self.$router.go();
            } else {
              self.err_msg = response.data.message;
              self.dismissCountDown = 10;
            }
          })
          .catch(function (error) {
            self.submitted = false; //Enable Button
          });
      }
    },
  },
};
</script>
<style>
div .error {
  color: red;
}

.hasError label {
  color: red;
}
</style>
